module.exports = __webpack_public_path__ + "img/slide2.6ec87784.jpg";